/**
 * Маршрути сторінок оболонки застосунку (прототип v4, ліве меню Головної): «Моя робота» (призначені мені, термін цього тижня, прострочено),
 * «Нещодавні», «Обране», бізнес-аналітика (огляд, навантаження, тенденції), учасники й запрошення, огляд напряму (`/<група>` — slug групи
 * верхнього меню), профіль (?tab= — вкладка: account | appearance | menu); системні модулі «Адміністрування» й «Налаштування»
 * (огляд і розділи — /admin/:section, /customize/:section[/:item]). Робочий простір в адресі не пишеться (ADR-028).
 */
export const appRoutes = {
  /** «Створити робочий простір» (прототип v4 screen 'onboard'; сторінки входу — src/app/auth) — поза оболонкою простору. */
  newWorkspace: () => '/onboarding',
  work: (view: string) => `/work/${view}`,
  recent: () => '/recent',
  favourites: () => '/favourites',
  bi: (view: string) => `/bi/${view}`,
  members: () => '/members',
  invitations: () => '/members/invitations',
  area: (group: string) => `/${encodeURIComponent(group)}`,
  profile: (tab?: string) => `/profile${tab ? `?tab=${tab}` : ''}`,
  admin: (section?: string) => `/admin${section ? `/${section}` : ''}`,
  customize: (section?: string, item?: string) => `/customize${section ? `/${section}` : ''}${item ? `/${encodeURIComponent(item)}` : ''}`,
};
